module.exports = __webpack_public_path__ + "img/ede3779.png";